/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const unmatchedQuoteSchema = z.object({
  quote: z.string(),
  character: z.string().nullable(),
});

export type IUnmatchedQuote = z.infer<typeof unmatchedQuoteSchema>;

export const quoteImportStatusSchema = z.object({
  exists: z.boolean(),
  wikiquotePageTitle: z.string().optional(),
  quotesFound: z.number().optional(),
  challengesCreated: z.number().optional(),
  clipsCreated: z.number().optional(),
  quotesUnmatched: z.number().optional(),
  unmatched: z.array(unmatchedQuoteSchema).optional(),
  quotesChildCollectionId: z.number().nullable().optional(),
  importedAt: z.number().nullable().optional(),
  error: z.string().nullable().optional(),
});

export type IQuoteImportStatus = z.infer<typeof quoteImportStatusSchema>;

export const getQuoteImportStatusV1ResponseSchema = createApiResponseSchema(
  quoteImportStatusSchema,
) as import('zod').ZodSchema<IAPI<IQuoteImportStatus>>;

export type IGetQuoteImportStatusV1Response = IAPI<IQuoteImportStatus>;
